import React from 'react';
import SerachEventBoxHorizontal from '../search/search_event_box_horizontal';
import moment from 'moment';

const fullname_disp = (user) => {
  if (user.is_fullname_hidden && user.is_verified_identity) {
    return `@${user.tunagate_id}(本人確認済)`;
  } else if (!user.is_fullname_hidden && user.is_verified_identity) {
    return `${user.familyname} ${user.firstname}(本人確認済)`;
  } else {
    return `${user.familyname} ${user.firstname}`;
  }
};

const FeedItem = ({
  currentUser,
  userFeed,
  openConfirmModal,
  friendsFullnames,
}) => {
  if (!userFeed || !userFeed.user || !currentUser) {
    return null;
  }

  const event = userFeed.event || userFeed.public_event;
  const album = userFeed.album || userFeed.public_album;

  return (
    <div key={userFeed.id} className="col-12 border-bottom">
      <div className="card border-0 bg-white pt-3 pb-4 px-0 text-fz-13px">
        {userFeed.user.id === currentUser.id ? (
          <div className="dropdown dropleft">
            <img
              style={{ padding: '0 2px 0 12px' }}
              id="dropdownMenu"
              className="position-absolute position--headerright text-black-20 text-fz-18px"
              data-toggle="dropdown"
              src="/assets2019/img/icon_reader.svg"
              alt=""
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenu">
              <button
                onClick={() => openConfirmModal(userFeed.id)}
                className="dropdown-item btn btn-light text-danger text-center"
                type="button"
              >
                削除する
              </button>
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="row">
          <div className="col-9">
            <a href={`/member/profile/${userFeed.user.tunagate_id}`}>
              <img
                className="lazyload rounded-circle mr-2"
                width="40"
                src={userFeed.user.avatar_thumb}
              />
              <span className="text-dark-gray text-fw-bold">
                @{userFeed.user.tunagate_id}
              </span>
            </a>
            {friendsFullnames.findIndex(
              (user) => user.id === userFeed.user.id
            ) != -1 ? (
              <span className="ml-2 text-gray text-fz-small">
                {
                  friendsFullnames[
                  friendsFullnames.findIndex(
                    (user) => user.id === userFeed.user.id
                  )
                  ]['view_full_name']
                }
              </span>
            ) : currentUser.id === userFeed.user.id ? (
              <span className="ml-2 text-gray text-fz-small">
                {fullname_disp(currentUser)}
              </span>
            ) : (
              ''
            )}
          </div>
          <div className="col-3" style={{ paddingTop: '10px' }}>
            <div className="text-gray text-fz-xs text-right">
              {userFeed.created_at_time_ago_format
                ? `${userFeed.created_at_time_ago_format}`
                : moment(userFeed.created_at).format('YYYY/MM/DD HH:mm')}
            </div>
          </div>
        </div>
        <div className="mt-2">
          <p
            className="text-fz-13px ml-5"
            dangerouslySetInnerHTML={{ __html: userFeed.body_url_to_link }}
          />
          {/* <p className="text-fz-11px card border-0 bg-white mb-0 p-2" dangerouslySetInnerHTML={{__html : replyComment.comment_display}}></p> */}
        </div>
        {event && event.circle && (
          <SerachEventBoxHorizontal
            circle={event.circle}
            eventItem={event}
            currentUser={currentUser}
            customClass={'mt-1 ml-5'}
          />
        )}
        {album && album.albums_photos && (
          <div className="album-list-item ml-5">
            <div
              className="album-list"
              data-cat="1"
              style={{ textAlign: 'center' }}
            >
              <a
                className="album-top-photo-wrap"
                href={`/circle/${album.circle.id}/album/${album.id}`}
              >
                <img
                  className={'photo-w w-100 rounded'}
                  src={album.albums_photos[0].main_image_large}
                />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedItem;
